import { useEffect, useState } from 'react'

export interface MaintenanceCountdown {
  remaining: number
  endsAt: Date
  isOverdue: boolean
}

/**
 * Counts down to a fixed, absolute end time so every visitor sees the same
 * remaining time regardless of when they landed on the page or reloaded.
 */
export function useMaintenanceCountdown(endsAtIso: string): MaintenanceCountdown {
  const endsAt = new Date(endsAtIso)
  const [remaining, setRemaining] = useState(() => Math.max(0, endsAt.getTime() - Date.now()))

  useEffect(() => {
    const target = new Date(endsAtIso).getTime()
    const tick = () => setRemaining(Math.max(0, target - Date.now()))
    tick()
    const timer = window.setInterval(tick, 1000)
    return () => window.clearInterval(timer)
  }, [endsAtIso])

  return { remaining, endsAt, isOverdue: remaining === 0 }
}
